module.exports = __webpack_public_path__ + "static/img/vision_values.6f6deded.png";